import { cx } from '@chakra-ui/utils';
import type {
  ContainerProps as ReactSelectContainerProps,
  OptionTypeBase,
} from 'react-select';

import { Box, type BoxProps } from '@frontend/components';

import { useSelectStyles } from '../SelectStylesContext';
import { BASE_CLASS_NAME } from '../const';

export type SelectContainerProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectContainerProps<OptionType, IsMulti> & {
  innerProps: BoxProps;
};

export const SelectContainer = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  children,
  innerProps,
}: SelectContainerProps<OptionType, IsMulti>) => {
  const { selectContainer: selectContainerStyles } = useSelectStyles();

  return (
    <Box
      {...innerProps}
      className={cx(BASE_CLASS_NAME, innerProps.className)}
      __css={selectContainerStyles}
    >
      {children}
    </Box>
  );
};
